export { default } from './IndexFormRowLabelGroup';
